/**
 * @file: useMaintenancePlanDetails.ts
 *
 * Infinite list over the detail-centric maintenance-plan search. Rows come
 * back ordered by order then detail-creation time, so consecutive rows share
 * an order — the screen groups them client-side (see `groupPlanDetails`).
 */

import { useInfiniteList } from '@euler/functions/useInfiniteList';
import { MaintenancePlanSearchParams } from '@euler/model';
import { MaintenancePlanDetailListItem } from '@euler/model/task-detail';
import { useServiceFactory } from '@euler/services/factory';

export const useMaintenancePlanDetails = (options?: { limit?: number }) => {
  const limit = options?.limit ?? 20;
  const { maintenancePlanService } = useServiceFactory();
  return useInfiniteList<
    MaintenancePlanDetailListItem,
    MaintenancePlanSearchParams
  >({
    limit,
    keyExtractor: x => String(x.id),
    query: async (offset, params) =>
      await maintenancePlanService.searchDetails(params ?? {}, offset, limit),
  });
};
